import { takeLeading, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/field-representatives/actions';
import fieldRepApi from 'src/services/api/field-representatives';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* reset(id: number) {
  try {
    const response = yield call(fieldRepApi.reset, id);
    yield put(Creators.fieldRepresentativesResetRequestSuccess(response));
  } catch (e) {
    //TODO add error handling in a function
    let error = e.response;
    DBErrorMonitor.captureException(e, { saga: 'reset', entity: 'fieldRep' });
    handleErrorResponse(error);
    yield put(Creators.fieldRepresentativesResetRequestError(error));
  }
}

export function* watchReset() {
  yield takeLeading(Types.FIELD_REPRESENTATIVES_RESET_REQUEST, reset);
}

export default watchReset;
